module.exports = __webpack_public_path__ + "img/turkey.6817b566.svg";